import { http } from './config/config-receituario'

const buildHeaders = (token) => ({
  key: token,
  Authorization: token,
})

export default {
  enqueueJobs(token, payload) {
    return http.post('agronomic-import/jobs/enqueue', payload, {
      headers: buildHeaders(token),
    })
  },
  listJobs(token, params = {}) {
    return http.get('agronomic-import/jobs', {
      headers: buildHeaders(token),
      params,
    })
  },
  getSummary(token) {
    return http.get('agronomic-import/jobs/summary', {
      headers: buildHeaders(token),
    })
  },
  listJobLogs(token, id, limit = 50) {
    return http.get(`agronomic-import/jobs/${id}/logs`, {
      headers: buildHeaders(token),
      params: { limit },
    })
  },
  listUrgentProducts(token, limit = 100) {
    return http.get('agronomic-import/jobs/produtos-urgentes', {
      headers: buildHeaders(token),
      params: { limit },
    })
  },
  runJobs(token, limit = 10) {
    return http.post('agronomic-import/jobs/run', null, {
      headers: buildHeaders(token),
      params: { limit },
    })
  },
}
